import React, { useEffect, useState } from "react";
import { Row, Col, Card, Spin, message, Table, Image, Tooltip, Divider } from "antd";
import axios from "axios";
import StatCard from "../components/Dashboard/StatCard";
import OrdersChart from "../components/Dashboard/OrdersChart";
import RevenueChart from "../components/Dashboard/RevenueChart";
import CarCategoryChart from "../components/Dashboard/CarCategoryChart";
import AddonUsageChart from "../components/Dashboard/AddonUsageChart";
import logo from '../../logo.png'
import { CustomerServiceOutlined } from "@ant-design/icons";

const ENDPOINTS = {
  BASE: "https://api.hemacabs.com/api/v1/",
  DRIVERS: "addon_services/driver",
  CARS: "product/cars/admin",
  SERVICES: "addon_services/services",
  COUPONS: "addon_services/coupons-offers",
  ORDERS: "product/orders"
};

const DashboardPage = () => {
  const [orders, setOrders] = useState([]);
  const [cars, setCars] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [services, setServices] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [ordersRes, carsRes, driversRes, servicesRes, couponsRes] =
          await Promise.all([
            axios.get(`${ENDPOINTS.BASE}${ENDPOINTS.ORDERS}`),
            axios.get(`${ENDPOINTS.BASE}${ENDPOINTS.CARS}`),
            axios.get(`${ENDPOINTS.BASE}${ENDPOINTS.DRIVERS}`),
            axios.get(`${ENDPOINTS.BASE}${ENDPOINTS.SERVICES}`),
            axios.get(`${ENDPOINTS.BASE}${ENDPOINTS.COUPONS}`)
          ]);

        console.log("ordersRes", ordersRes);
        console.log("servicesRes", servicesRes);



        setOrders(ordersRes?.data?.data || []);
        setCars(carsRes?.data?.data || []);
        setDrivers(Array.isArray(driversRes?.data?.data) ? driversRes.data.data : []);
        setServices(Array.isArray(servicesRes?.data?.data) ? servicesRes.data.data : []);
        setCoupons(Array.isArray(couponsRes?.data?.data) ? couponsRes.data.data : []);
      } catch (err) {
        console.error("Dashboard API Error:", err);
        message.error("Failed to load dashboard data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const totalRevenue = orders.reduce((sum, order) => {
    try {
      const pricing = JSON.parse(order.pricing || "{}");
      return sum + (pricing.finalPrice || 0);
    } catch {
      return sum;
    }
  }, 0);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 100 }}>
        <Spin size="large" />
      </div>
    );
  }



  return (
    <div>
      <Row >
        <Card style={{ width: '100%' }} size="small">
          <div style={{display:'flex', justifyContent:'center'}}>
            <Image style={{ width: '220px' }} src={logo} />
            {/* <Tooltip title="Support">
              <CustomerServiceOutlined style={{ fontSize: 25, cursor: "pointer" }} />
            </Tooltip> */}

          </div>
        </Card>
      </Row>

      <Divider style={{margin:'8px 0'}}/>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <StatCard title="Total Orders" value={orders.length} type="orders" />
        </Col>

        <Col xs={24} sm={12} md={6}>
          <StatCard title="Total Cars" value={cars.length} type="cars" />
        </Col>

        <Col xs={24} sm={12} md={6}>
          <StatCard
            title="Revenue"
            value={`₹${totalRevenue.toLocaleString()}`}
            type="revenue"
          />
        </Col>

        <Col xs={24} sm={12} md={6}>
          <StatCard
            title="Services"
            value={services.length}
            type="addons"
          />
        </Col>
      </Row>


      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        {/* <Col xs={24} lg={8}>
          <Card title="Orders" bordered={false}>
            <OrdersChart orders={orders} />
          </Card>
        </Col> */}

        <Col xs={24} lg={12}>
          <Card title="Revenue by Order" bordered={false}>
            <RevenueChart orders={orders} />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card title="Cars by Category" bordered={false}>
            <CarCategoryChart cars={cars} />
          </Card>
        </Col>
      </Row>


      {/* ================== TABLES ================== */}
      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title="Drivers" bordered={false}>
            <Table
              dataSource={drivers}
              rowKey="id"
              pagination={{ pageSize: 5 }}
              columns={[
                { title: "Name", dataIndex: "driver_name" },
                { title: "Mobile", dataIndex: "mobile" },
                { title: "License", dataIndex: "license_no" },
                { title: "Experience (yrs)", dataIndex: "experience" },
              ]}
            />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Services" bordered={false}>
            <Table
              dataSource={services}
              rowKey="id"
              pagination={{ pageSize: 5 }}
              columns={[
                {
                  title: "#",
                  dataIndex: "name",
                  render: (text, record) => (
                    <Image
                      src={`https://api.hemacabs.com${record.upload_img}`}
                      width={50}
                      height={50}
                      style={{ objectFit: "cover", marginRight: 8, borderRadius: 8 }}
                    />

                  )
                },
                { title: "Service", dataIndex: "name" },
                // { title: "Status", dataIndex: "status" }
              ]}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24}>
          <Card title="Coupons / Offers" bordered={false}>
            <Table
              dataSource={coupons}
              rowKey="id"
              pagination={{ pageSize: 5 }}
              columns={[
                { title: "Name", dataIndex: "c_name" },
                { title: "Code", dataIndex: "c_code" },
                { title: "Discount (%)", dataIndex: "dis_per" },
                // { title: "Status", dataIndex: "status" }
              ]}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardPage;
